import { formatInTimeZone } from 'date-fns-tz';

const getDayName = (date: Date, nowDate: Date, timezone: string): string => {
  const formatDate = (d: Date) => formatInTimeZone(d, timezone, 'yyyy-MM-dd');

  // is today
  if (formatDate(date) === formatDate(nowDate)) return 'Today';

  // is yesterday
  const yesterday = new Date(nowDate);
  yesterday.setDate(nowDate.getDate() - 1);
  if (formatDate(date) === formatDate(yesterday)) return 'Yesterday';

  // default to day of the week
  const dayOfWeek = formatInTimeZone(date, timezone, 'EEEE');
  return dayOfWeek;
};

export default getDayName;
